module.exports = __webpack_public_path__ + "img/envelope2.d3eb1a09.svg";